import React from "react";
import ellipse from "../../../../assets/layoutBackground/ellipse-header-mobile.webp";

const LayoutHeader = () => {
  return (
    <div className="relative w-full mb-7 flex flex-col items-center lg:hidden">
      <img
        src={ellipse}
        alt="Background decoration element"
        className="absolute left-0 right-0 mx-auto -translate-y-1/3"
      />
      <h1 className="text-2xl leading-9 font-bold text-black dark:text-white z-[1]">
        XBR Node
      </h1>
      <p className="text-xs text-center leading-[18px] text-semiBlack dark:text-semiWhite z-[1]">
        Build a long lasting crypto portfolio by following your favorite pool
        creators, Get XBR Founder's Node NOW...
      </p>
    </div>
  );
};

export default LayoutHeader;
